import { RunningExperiments, useExperiments } from 'state/experiments';

export const usePaymentCheckoutRedesignExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.PaymentCheckoutRedesign, 'treatment', {
    skipExposureLogging: true,
  });
};
